
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/chat/conversation-list-item-avatar",
      function () {
        return require("private-next-pages/x/api/chat/conversation-list-item-avatar.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/chat/conversation-list-item-avatar"])
      });
    }
  